(function () {
  'use strict';

  angular
    .module('vcpatdocs')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.patdocs', {
        url: '/patdocs',
        views: {
          'playgroundmain@playground': {
            template: `
              <!--<h3 class="alert alert-info"><tt>&lt;patdocssearch patdocs="" patdocsref="" editinplace="true"&gt;</tt></h3><div ui-view="patdocssearchview"></div>-->
              <!--<h3 class="alert alert-info"><tt>&lt;patdocssearch patdocs="" patdocsref="" parentsave=""&gt;</tt></h3><div ui-view="patdocssearchview2"></div>-->
              <!--<h3 class="alert alert-info"><tt>&lt;patdocseditor patdocs="" mode="" onClose=""&gt;</tt></h3><div ui-view="patdocseditview"></div>-->
              <h3 class="alert alert-info"><tt>&lt;newref consultid="" clientid=""&gt;</tt></h3><div ui-view="patdocsnewrefview"></div>
              <h3 class="alert alert-info"><tt>&lt;newaide consultid="" clientid=""&gt;</tt></h3><div ui-view="patdocsnewaideview"></div>
              <h3 class="alert alert-info"><tt>&lt;refcounter consultid=""&gt;</tt></h3><div ui-view="patdocsrefcounterview"></div>
              <h3 class="alert alert-info"><tt>&lt;aidecounter consultid=""&gt;</tt></h3><div ui-view="patdocsaidecounterview"></div>
              <h3 class="alert alert-info"><tt>&lt;labvalueconfig&gt;</tt></h3><div ui-view="labvalueconfigview"></div>
              <h3 class="alert alert-info"><tt>&lt;imagingconfig&gt;</tt></h3><div ui-view="imagingconfigview"></div>
              <h3 class="alert alert-info"><tt>&lt;aideconfig&gt;</tt></h3><div ui-view="aideconfigview"></div>
              <h3 class="alert alert-info"><tt>&lt;testpdf&gt;</tt></h3><div ui-view="testpdfview"></div>
              <!--<h3 class="alert alert-info"><tt>&lt;patdocslist patdocss="?"&gt;</tt></h3><div ui-view="patdocslistview"></div>-->
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vcpatdocs entered');
        }
      });


    $stateProvider
      .state('playground.patdocs.allcomponents', {
        url: '/allcomponents',
        resolve: {
          clientid: function () {
            return '586fcf4fa60359ae2a632d64';
          },
          consultid: function () {
            return '58f88208b148b776e918dd0d';
          },
          patdocsref: function () {
            return '';
          },
          somepatdocs: function (Patdocs) {
            return Patdocs.$find('572b31b07c01597e3e150923');
          },
          allpatdocss: function (Patdocs) {
            return Patdocs.$search({active: true});
          },
          parentsavesearch: function () {
            return function (patdocs, patdocsref) {
              console.log('debug: dummy parentsave called for patdocssearch with: ', patdocs, patdocsref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'patdocssearchview@playground.patdocs': {
            component: 'patdocssearch',
            bindings: {
              patdocs: 'patdocs',
              patdocsref: 'patdocsref',
              editinplace: 'eip'
            }
          },
          /*'patdocssearchview2@playground.patdocs': {
            component: 'patdocssearch',
            bindings: {
              patdocs: 'patdocs',
              patdocsref: 'patdocsref',
              parentsave: 'parentsavesearch'
            }
          },
          'patdocseditview@playground.patdocs': {
            component: 'patdocseditor',
            bindings: {
              patdocs: 'somepatdocs'
            }
          },*/
          'patdocsnewrefview@playground.patdocs': {
            component: 'newref',
            bindings: {}
          },
          'patdocsnewaideview@playground.patdocs': {
            component: 'newaide',
            bindings: {}
          },
          'patdocsrefcounterview@playground.patdocs': {
            component: 'refcounter',
            bindings: {}
          },
          'patdocsaidecounterview@playground.patdocs': {
            component: 'aidecounter',
            bindings: {}
          },
          'labvalueconfigview@playground.patdocs': {
            component: 'labvalueconfig',
            bindings: {}
          },
          'imagingconfigview@playground.patdocs': {
            component: 'imagingconfig',
            bindings: {}
          },
          'aideconfigview@playground.patdocs': {
            component: 'aideconfig',
            bindings: {}
          },
          'patdocslistview@playground.patdocs': {
            component: 'patdocslist',
            bindings: {
              patdocss: 'allpatdocss'
            }
          },
          'testpdfview@playground.patdocs': {
            component: 'testpdf',
            bindings: {
            }
          }
        },
        onEnter: function () {
          console.log('playground.patdocs.allcomponents entered');
        }
      });


  }// all routes


}());






